import { useTranslation } from 'react-i18next';

import { quotaI18nKeys } from 'components/quota-components/i18n';

import { useUserStatus } from '../../../hooks/useUserStatus';

import { useQuotaActions } from './useQuotaActions';

type HookParams = {
  onNotifyAdminSuccess?: VoidFunction | undefined;
};

type QuotaNotificationConfig = {
  title: string;
  description: string;
  isLoading: boolean;
  isSuccess?: boolean;
  buttonText?: string;
  onButtonClick?: VoidFunction;
};

export const useLowQuotaNotificationConfig = ({ onNotifyAdminSuccess }: HookParams = {}): QuotaNotificationConfig => {
  const { t } = useTranslation();

  const { isNoTouch, isAdmin } = useUserStatus();

  const { onNotifyAdmin, onGoToManageDataCreditsPage, isNotifyingAdmin, hasNotifiedAdmin } = useQuotaActions();

  if (isNoTouch) {
    return {
      title: String(t(quotaI18nKeys.needMoreCreditsTitle)),
      description: String(t(quotaI18nKeys.needMoreCreditsDescription)),
      isLoading: false,
    };
  }

  if (isAdmin) {
    return {
      title: String(t(quotaI18nKeys.lowCreditsTitle)),
      description: String(t(quotaI18nKeys.manageCreditsText)),
      isLoading: false,
      buttonText: String(t(quotaI18nKeys.manageCredits)),
      onButtonClick: onGoToManageDataCreditsPage,
    };
  }

  return {
    title: String(t(quotaI18nKeys.lowCreditsTitle)),
    description: String(t(quotaI18nKeys.notifyAdminText)),
    isLoading: isNotifyingAdmin,
    isSuccess: hasNotifiedAdmin,
    buttonText: String(t(quotaI18nKeys.notifyAdmin)),
    onButtonClick: () => onNotifyAdmin(undefined, { onSuccess: onNotifyAdminSuccess }),
  };
};
